import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Chart from "../Charts/Chart";
import { getIntraDayData, getPriceDeltaValues } from "../Service/data";
import { CardHeader } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";

import { useSearchParams } from "react-router-dom";
import { createSearchParams, useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import CandleChartSubHeader from "./CandleChartSubHeader";


import ShowChartIcon from "@mui/icons-material/ShowChart";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";

import { useTheme } from "@mui/material/styles";

const CandleChart = (props) => {
  const [data, setData] = useState();
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);
  let [searchParams, setSearchParams] = useSearchParams();
  const [currentTime, setCurrentTime] = useState(1);
  const [showRsi, setShowRsi] = useState(false);
  const [showMacd, setShowMacd] = useState(false);
  const [showAdx, setShowAdx] = useState(false);
  const [showRoc, setShowRoc] = useState(false);
  const [showBB, setShowBB] = useState(false);

  const [chartMode, setChartMode] = useState(0);
  const navigate = useNavigate();
  const theme = useTheme();

  const [fullScreenOpen, setFullScreenOpen] = React.useState(false);

  useEffect(() => {
    let params = new URLSearchParams(searchParams);
    const time = params.get("time");
    setCurrentTime(time);

    const rsi = params.get("showRsi");
    setShowRsi(rsi);

    const macd = params.get("showMacd");
    setShowMacd(macd);

    const adx = params.get("showAdx");
    setShowAdx(adx);

    const roc = params.get("showRoc");
    setShowRoc(roc);

    const bb = params.get("showBB");
    setShowBB(bb);
  }, [searchParams]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        getIntraDayData(props.title, currentTime).then((data) => {
          setData(data);
          setLoading(false);
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (currentTime) {
      fetchData();
    }
  }, [currentTime]);

  useEffect(() => {
    if (data !== undefined && data !== null && data.length > 0) {
      // setLoading(false);
      console.log(data);
      setNoData(false);
      if (props.title.includes(".")) {
        setChartMode(1)
      }
    }
  }, [data]);

  const handleOnFullScreenClick = (name) => {
    setFullScreenOpen(true);
  };

  const handleFullscreenClose = () => {
    setFullScreenOpen(false);
  };

  const handleSymbolClick = () => {
    searchParams.append("symbol", props.title);
    if (props.indexStock !== props.title) {
      searchParams.append("indexStock", props.indexStock);
    }
    navigate({
      pathname: "/chart",
      search: createSearchParams(searchParams).toString(),
    });
  };

  const actions = props.renderOptions ? (
    <ButtonGroup variant="contained" aria-label="outlined primary button group">
      <IconButton
        size="small"
        onClick={() => {
          handleOnFullScreenClick();
        }}
      >
        <OpenInFullIcon />
      </IconButton>
      <IconButton
        color={chartMode === 0 ? "success" : "primary"}
        onClick={() => {
          setChartMode(0);
        }}
      >
        <CandlestickChartIcon />
      </IconButton>
      <IconButton
        color={chartMode === 1 ? "success" : "primary"}
        onClick={() => {
          setChartMode(1);
        }}
      >
        <ShowChartIcon />
      </IconButton>
    </ButtonGroup>
  ) : null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "fit-content",
      }}
    >
      <Card
        style={{
          width: "fit-content",
          minWidth: "450px",
          minHeight: "200px",
          height: "fit-content",
          margin: "10px",
          padding: "0px",
          background: `${theme.palette.background.default}`,
        }}
      >
        <CardHeader
          title={
            <Typography
              style={{ marginBottom: "10px" }}
              onClick={handleSymbolClick}
            >
              {props.title}
            </Typography>
          }
          action={actions}
          subheader={<CandleChartSubHeader name={props.title} />}
        />
        <CardContent>
          {loading && <CircularProgress />}
          {noData && data == undefined ? (
            <Typography>No data was received</Typography>
          ) : (
            <Chart
              data={data}
              time={currentTime}
              width={props.width}
              height={props.height}
              title={props.title}
              rsi={showRsi}
              macd={showMacd}
              adx={showAdx}
              roc={showRoc}
              bb={showBB}
              chartMode={chartMode}
            />
          )}
        </CardContent>
      </Card>
      <Dialog
        onClose={handleFullscreenClose}
        open={fullScreenOpen}
        maxWidth="xl"
      >
        <div>
          <CandleChart
            title={props.title}
            width={1000}
            height={600}
          ></CandleChart>
        </div>
      </Dialog>
    </div>
  );
};

export default CandleChart;
